import React, { useEffect, useRef, useState } from 'react';
import { CSSProperties } from 'styled-components';

interface KeypadProps {
  identifier: string;
  type?: string;
  cardnumber?: string;
  setStateFunction: (any) => void;
  placeholderText: string;
  textLength: string;
  isError: boolean;
  setError: (any) => void;
  css: CSSProperties;
  keypadToken: string;
}

const KeyPad = ({
  identifier,
  type,
  cardnumber,
  setStateFunction,
  placeholderText,
  textLength,
  isError,
  setError,
  css,
  keypadToken,
}: KeypadProps) => {
  const divRef = useRef<any>(null);

  useEffect(() => {
    if (keypadToken) {
      renderKeypad(keypadToken);
    }
  }, [keypadToken, type]);

  useEffect(() => {
    if (identifier === 'cvc') {
      renderKeypad(keypadToken);
    }
  }, [textLength]);

  const validateTextLength = count => {
    if (count === Number(textLength)) {
      setError(false);
    }
  };

  const keypadButtonClick = count => {
    validateTextLength(count);

    setStateFunction(prev => {
      return {
        ...prev,
        length: count,
      };
    });
  };

  const keyPadInit = (element, option, token, encryptType) => {
    //@ts-ignore
    const keypad = new KeypadSuit(element, option);
    //@ts-ignore
    keypad.init(token, encryptType, Module);
    // keypad.init(token, encryptType);
  };

  const keypadFinish = (result, mac, token, key) => {
    if (identifier === 'firstKeypad') {
      const nextRef = document.querySelectorAll('div.input.secondKeypad')[0]
        .children[1] as HTMLElement;
      // const shuffleBtn = document.querySelectorAll(
      //   '._stealien_keybutton_shuffle',
      // )[0] as HTMLElement;
      // if (shuffleBtn) {
      //   console.log('in firstKeypad', shuffleBtn);
      //   shuffleBtn.click();
      // }
      if (nextRef) {
        nextRef.focus();
        nextRef.click();
      }
    } else if (identifier === 'secondKeypad') {
      const nextRef = document.querySelectorAll('div.input.lastCardNumber')[0]
        .children[1] as HTMLElement;
      if (nextRef) {
        nextRef.focus();
        nextRef.click();
      }
    } else if (identifier === 'expiryDateMonth') {
      const nextRef = document.querySelectorAll('div.input.expiryDateYear')[0]
        .children[1] as HTMLElement;

      if (nextRef) {
        nextRef.focus();
        nextRef.click();
      }
    } else if (identifier === 'expiryDateMonthKeyin') {
      const nextRef = document.querySelectorAll(
        'div.input.expiryDateYearKeyin',
      )[0].children[1] as HTMLElement;

      if (nextRef) {
        nextRef.focus();
        nextRef.click();
      }
    } else if (identifier === 'expiryDateYear') {
      const nextRef = document.querySelectorAll('div.input.cvc')[0]
        .children[1] as HTMLElement;

      if (nextRef) {
        nextRef.focus();
        nextRef.click();
      }
    } else if (identifier === 'cvc') {
      const nextRef = document.getElementsByName('email')[0] as HTMLElement;

      if (nextRef) {
        nextRef.focus();
        nextRef.click();
      }
    }

    setStateFunction(prevState => {
      return {
        ...prevState,
        data: result,
        token: token,
        hmac: mac,
      };
    });
  };

  const renderKeypad = token => {
    const option = {
      type: 'PIN',
      shuffle: 'RANDOM',
      // shuffleType: 'RANDOM',
      useKorean: true,
      length: Number(textLength),
      null_key: `R`,
      clearTextByFinish: false,
      getLastCharacterByInput: false,
      split: false,
      clear_key: 'ㅤㅤㅤ',
      append: ['SHUFFLE', 'CLEAR', 'ERASE'],
      set_attribute: {
        1: [
          { key: 'tabIndex', value: '5' },
          { key: 'title', value: '-1' },
          { key: 'aria-readonly', value: 'true' },
        ],
        Q: [{ key: 'tabIndex', value: '-1' }],
        '@': [{ key: 'tabIndex', value: '-1' }],
        SHUFFLE: [{ key: 'tabIndex', value: '-1' }],
        all_button: [{ key: 'tabIndex', value: '-1' }],
      },
      onclose: () => {},
      onButtonClick: count => {
        keypadButtonClick(count);
      },
      onFinish: (result, mac, token, key) => {
        // ✅ DOM으로 키패드 강제 숨김
        const allKeypads = document.querySelectorAll(
          '._stealien_keypad_border',
        );
        allKeypads.forEach(el => {
          if (el instanceof HTMLElement) {
            el.style.display = 'none';
          }
        });

        keypadFinish(result, mac, token, key);
      },
      onFocus: () => {
        if (identifier === 'expiryDateMonth') {
          const tab = document.getElementById('tab-1');
          if (tab) {
            tab.scrollTop = 160;
          }
        }
      },
    };
    switch (identifier) {
      case 'firstKeypad':
        divRef.current?.classList.add('firstKeypad');
        keyPadInit(
          divRef.current?.children[1] as HTMLInputElement,
          option,
          token,
          'AES128',
        );
        break;
      case 'secondKeypad':
        divRef.current.classList.add('secondKeypad');
        keyPadInit(
          divRef.current?.children[1] as HTMLInputElement,
          option,
          token,
          'AES128',
        );
        break;
      case 'expiryDateMonth':
        divRef.current.classList.add('expiryDateMonth');
        keyPadInit(
          divRef.current?.children[1] as HTMLInputElement,
          option,
          token,
          'AES128',
        );
        break;
      case 'expiryDateMonthKeyin':
        divRef.current.classList.add('expiryDateMonthKeyin');
        keyPadInit(
          divRef.current?.children[1] as HTMLInputElement,
          option,
          token,
          'AES128',
        );
        break;
      case 'expiryDateYear':
        divRef.current.classList.add('expiryDateYear');
        keyPadInit(
          divRef.current?.children[1] as HTMLInputElement,
          option,
          token,
          'AES128',
        );
        break;
      case 'expiryDateYearKeyin':
        divRef.current.classList.add('expiryDateYearKeyin');
        keyPadInit(
          divRef.current?.children[1] as HTMLInputElement,
          option,
          token,
          'AES128',
        );
        break;
      case 'identityNumber':
        divRef.current.classList.add('identityNumber');
        keyPadInit(
          divRef.current?.children[1] as HTMLInputElement,
          option,
          token,
          'AES128',
        );
        break;
      case 'cvc':
        divRef.current.classList.add('cvc');
        keyPadInit(
          divRef.current?.children[1] as HTMLInputElement,
          option,
          token,
          'AES128',
        );
        break;
      case 'keypadPassword':
        divRef.current.classList.add('keypadPassword');
        keyPadInit(
          divRef.current?.children[1] as HTMLInputElement,
          option,
          token,
          'AES128',
        );
        break;
    }
  };

  return (
    <>
      <p style={{ display: 'none' }}>{placeholderText}</p>
      <div
        className={
          isError ? `input ${identifier} error` : `${identifier} input`
        }
        ref={divRef}
        style={css}
      >
        <a></a>
        <input placeholder={placeholderText} />
      </div>
    </>
  );
};

export default React.memo(KeyPad);
